import React from 'react';

const Contact = () => {
  return (
    <div className="bg-black shadow">
      <footer id="contact">
        <div className="container mx-auto px-4 text-center mb-4">
          <p className="text-white">&copy; 2024 Transparency Watch. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Contact;
